export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_q03_a.13ae60e6.png";